import React from 'react'
import IncentiveView from '../../components/incentive/IncentiveView'
import Navbar from '../../components/navbar/Navbar'

const ViewIncentivePage = () => {
    return (
        <>
            <section className="bajaj_main_block">
                <div className="container-fluid">
                    {/* Navbar */}
                    <div className="row">
                        <div className="col-12 p-0">
                            <Navbar content="VIEW INCENTIVE" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 p-0">
                            <IncentiveView />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ViewIncentivePage